import type { NitroFetchOptions } from 'nitropack'
import { fetchRetryParameters } from '~/composables/constants/api'

export const SEARCH_DOCUMENT_LIMIT = 5
export const SEARCH_SUGGESTION_LIMIT = 15
export const FACET_SUFFIX = 'f.'
export const CATEGORY_ID_KEY = 'category_id'
export const FACET_CATEGORY_ID = `${FACET_SUFFIX}${CATEGORY_ID_KEY}`
export const FLAGS_FILTER_KEY = 'flag_ids'

export const searchDefaultParameters: NitroFetchOptions<any> = {
  method: 'POST',
  headers: {
    accept: 'application/json',
    'Content-Type': 'application/json',
  },
  body: {
    searchText: '',
  },
  ...fetchRetryParameters,
}

export enum OutsideSources {
  Facebook = 'facebook_group',
}

export const OutsideSourcesList = [OutsideSources.Facebook]
